import { Component, OnInit, inject } from "@angular/core";
import { Store } from "@ngrx/store";
import { OAuthService } from "angular-oauth2-oidc";
import { Router } from "@angular/router";

import { ActionClear } from "@app/core/auth/identity/user.reducer";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";

@Component({
  template: '<div class="spinner-container"><mat-spinner></mat-spinner></div>',
  styleUrls: ["./logout.component.scss"],
  standalone: true,
  imports: [MatProgressSpinnerModule]
})
export class LogoutComponent implements OnInit {
  private oauthService = inject(OAuthService);
  private readonly store = inject<Store<any>>(Store);
  router = inject(Router);

  ngOnInit() {
    this.store.dispatch(new ActionClear());
    window.sessionStorage.clear();
    this.oauthService.logOut();
  }
}
